// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__uZw5C","label":"Category_label__2uynp","content":"Category_content__nXZEK","header":"Category_header__1fOBq","location":"Category_location__1Bima"};